import React from 'react';
import {createRoot} from 'react-dom/client';
import JshModule from '@core/scripts/helper/jsh-module';
import WithdrawalPageContent from '@account/pages/withdrawal/WithdrawalPageContent';
import TextsProvider from '@account/shared-components/providers/TextsProvider';

type WithdrawalPageModel = {
    texts: {[key: string]: string};
    friendlyCaptchaSiteKey: string;
    captchaEnabled: boolean;
    captchaV2Enabled: boolean;
    canNavigateBack: boolean;
    isApp: boolean;
    urls: {
        homeUrl: string;
        myAccountOverviewUrl: string;
        withdrawOrderUrl: string;
        serviceContactUrl: string;
    };
};

interface JshConfigWithPageModel {
    pageModel: WithdrawalPageModel;
}

const {moduleScope, config} = JshModule('withdrawal');

const {texts, friendlyCaptchaSiteKey, captchaEnabled, captchaV2Enabled, isApp, canNavigateBack, urls} = (config as JshConfigWithPageModel)
    .pageModel;

createRoot(moduleScope).render(
    <TextsProvider locales={texts}>
        <WithdrawalPageContent
            friendlyCaptchaSiteKey={friendlyCaptchaSiteKey}
            isCaptchaEnabled={captchaEnabled}
            isCaptchaV2Enabled={captchaV2Enabled}
            isApp={isApp}
            canNavigateBack={canNavigateBack}
            urls={urls}
        />
    </TextsProvider>,
);
